import { CirclePlayIcon, SparklesIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useMarkdownToHtml } from '@/hooks/useMarkdownToHtml';
import { cn } from '@/lib/utils';
import {
  selectStandaloneQuestion,
  selectIsStandaloneAltered,
} from '@/modules/tryIt/redux/selectors';
import { AmendPayload } from '@/shared/types/tryIt';

import { AmendWrapper } from '../../Messages/AmendWrapper/AmendWrapper';

import styles from './DetailsSection.module.scss';

interface Props {
  userMessage: string;
  amendPayload: AmendPayload;
  isAmended?: boolean;
}

export const StandaloneWrapper = ({ userMessage, amendPayload, isAmended }: Props) => {
  const { t } = useTranslation();
  const standaloneQuestion = useSelector(selectStandaloneQuestion);
  const isStandaloneAltered = useSelector(selectIsStandaloneAltered);
  const { html } = useMarkdownToHtml(standaloneQuestion);

  return (
    <div className={styles.step}>
      {isStandaloneAltered ? (
        <>
          <div className={styles.title}>
            <CirclePlayIcon size={16} className="text-foreground-muted" aria-hidden="true" />
            <span className="min-w-0 truncate text-sm leading-5 font-normal text-foreground-muted">
              {t('try_it.rephrased_by_the_virtual_agent')}
            </span>
          </div>
          <div className={styles.details}>
            <div className={styles.standalone}>
              <SparklesIcon size={16} className="text-ai" aria-hidden="true" />
              <span
                className="text-sm leading-5 font-normal text-foreground"
                dangerouslySetInnerHTML={{ __html: html }}
              />
            </div>
            <div className={styles.amendContainer}>
              <AmendWrapper amendPayload={amendPayload} isAmended={isAmended} />
            </div>
          </div>
        </>
      ) : (
        <>
          <div className={styles.title}>
            <CirclePlayIcon size={16} className="text-foreground-muted" aria-hidden="true" />
            <div
              className={cn(
                'text-sm leading-5 font-normal text-foreground-muted',
                styles.triggerMessage
              )}
            >
              {userMessage}
            </div>
          </div>
          <div className={styles.details}>
            {standaloneQuestion && (
              <div className={styles.amendContainer}>
                <AmendWrapper amendPayload={amendPayload} isAmended={isAmended} />
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};
